import React, { useState } from "react";
import { Box, Typography, CircularProgress } from "@mui/material";
import { styled } from "@mui/system";
import { update2FAType } from "api/api_register2FA";
import { FaRegEye } from "react-icons/fa";
import { clearLocalStorage } from "utils/storage";

const IrisSensor = styled(Box)(({ theme }) => ({
  width: "150px",
  height: "150px",
  border: "2px solid #1976d2",
  borderRadius: "50%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  cursor: "pointer",
  transition: "all 0.3s ease",
  "&:hover": {
    backgroundColor: "rgba(25, 118, 210, 0.1)",
  },
  [theme.breakpoints.down("sm")]: {
    width: "150px",
    height: "150px",
  },
}));

const AnimatedIris = styled(FaRegEye)(({ theme, scanning }) => ({
  fontSize: "80px",
  color: scanning ? "#1976d2" : "#757575",
  animation: scanning ? "pulse 1.5s infinite" : "none",
  "@keyframes pulse": {
    "0%": {
      transform: "scale(0.95)",
      boxShadow: "0 0 0 0 rgba(25, 118, 210, 0.7)",
    },
    "70%": {
      transform: "scale(1)",
      boxShadow: "0 0 0 10px rgba(25, 118, 210, 0)",
    },
    "100%": {
      transform: "scale(0.95)",
      boxShadow: "0 0 0 0 rgba(25, 118, 210, 0)",
    },
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "80px",
  },
}));

function Register2FAIris() {
  const [scanning, setScanning] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  // const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const requestUrl = `${process.env.REACT_APP_BASE_URL_PYTHON}/get_user_device`;
  const { username } = JSON.parse(localStorage.getItem("user")) || "";

  const handleScan = async () => {
    setScanning(true);
    setError("");
    setSuccess(false);
    try {
      const response = await fetch(requestUrl);
      const data = await response.json();
      setScanning(false);

      const user = data.UserInfoSearch.UserInfo.find((u) => u.employeeNo === username);

      if (user) {
        setSuccess(true);
        update2FAType(username, 9);
        setTimeout(() => {
          clearLocalStorage();
          window.location.href = "/authentication/sign-in";
        }, 1500);
      } else {
        setError("Không tìm thấy võng mạc. Vui lòng thử lại.");
      }
    } catch {
      setScanning(false);
      setError("Không tìm thấy thiết bị phù hợp vui lòng kết nối và thử lại.");
    }
  };

  return (
    <Box
      width={450}
      className="form-container"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: 2,
        height: "400px",
      }}
    >
      <Box className="fs-20 fw-700">Xác thực qua võng mạc</Box>
      <Box p={1} className="fs-14 gray-80 txt-align">
        Quét võng mạc sau đó nhấn nút để đăng ký xác thực
      </Box>
      <IrisSensor onClick={handleScan} aria-label="Scan Iris" role="button" tabIndex={0}>
        <AnimatedIris scanning={scanning} />
      </IrisSensor>
      {scanning && (
        <Box sx={{ mt: 2 }}>
          <CircularProgress />
        </Box>
      )}
      {error && (
        <Typography fontSize={14} color="error" sx={{ mt: 2 }}>
          {error}
        </Typography>
      )}
      {success && (
        <Typography fontSize={14} color="success.main" sx={{ mt: 2 }}>
          Xác thực thành công.
        </Typography>
      )}
      {/* <Box sx={{ mt: 3, display: "flex", flexDirection: isMobile ? "column" : "row", gap: 2 }}>
        <Button
          variant="contained"
          onClick={handleScan}
          disabled={scanning}
          startIcon={<FaRegEye />}
        >
          Scan Iris
        </Button>
      </Box> */}
    </Box>
  );
}

export default Register2FAIris;
